import { Theme } from '@mui/material';


const Tabs = (theme: Theme) => {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          borderTop: `1px solid ${theme.palette.divider}`,
          borderBottom: `1px solid ${theme.palette.divider}`,
          minHeight: theme.spacing(4),
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3),
        },
        indicator: {
          height: 0,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: theme.spacing(4),
          textTransform: 'none',
          paddingTop: theme.spacing(0),
          paddingBottom: theme.spacing(0),
          marginTop: theme.spacing(0.5),
          marginBottom: theme.spacing(0.5),
          borderRadius: theme.shape.borderRadius,
          fontWeight: 600,
          '&:hover': {
            color: theme.palette.text.primary,
          },
          '&.Mui-selected': {
            color: '#fff',
            background: theme.palette.secondary.dark,
          },
        },
      },
    },
  };
};

export default Tabs;
